import type { HealthResponse } from '@/types/api';
import { apiFetch } from './client';

export function getHealth(): Promise<HealthResponse> {
  return apiFetch<HealthResponse>('/health');
}
